<template>
    <div class="home-layout" v-bind:class="{ 'home-layout--expanded': isExpanded }">
        <aside v-if="!isBot"
               class="home-sidebar"
               v-bind:class="{ 'home-sidebar--expanded': isExpanded }">
            <div class="home-sidebar__top">
                <div class="home-sidebar__logo"
                     v-bind:class="{ 'home-sidebar__logo--expanded': isExpanded }"
                     aria-hidden="true">
                    {{ isExpanded ? "Hoo-ly" : "H" }}
                </div>
                <button class="home-sidebar__toggle"
                        type="button"
                        v-bind:aria-label="toggleMenuLabel"
                        v-bind:title="toggleMenuLabel"
                        v-on:click="isExpanded = !isExpanded">
                    <i class="fas fa-times" v-if="isExpanded"></i>
                    <i class="fas fa-bars" v-else></i>
                </button>
                <router-link class="home-mobile-exit"
                             :to="{ name: 'SignOut' }">
                    {{ $filters.localize("home.exit") }}
                </router-link>
            </div>
            <left-nav-menu v-bind:isExpanded="isExpanded"
                           v-bind:buttons="leftMenuButtons" />
        </aside>

        <nav v-if="!isBot" class="home-mobile-tabs" aria-label="Mobile navigation">
            <router-link v-for="button in mobileRouteButtons"
                         v-bind:key="button.path"
                         :to="{ name: button.path }"
                         class="home-mobile-tabs__link">
                {{ button.name }}
            </router-link>
        </nav>

        <div class="home-main">
            <main-nav-menu v-if="!isBot"
                           v-bind:buttons="topMenuButtons"
                           class="home-topbar"></main-nav-menu>
            <div class="home-content">
                <router-view />
            </div>
        </div>
    </div>
</template>

<script>
    import LeftNavMenu from "@/components/Navs/LeftNavMenu.vue";
    import MainNavMenu from "@/components/Navs/MainNavMenu.vue";
    export default {
        name: "Home",
        components: {
            LeftNavMenu,
            MainNavMenu,
        },
        computed: {
            isBot: {
                get() {
                    return this.$store.getters.isBot;
                },
            },
            toggleMenuLabel: {
                get() {
                    return this.isExpanded ? "Collapse menu" : "Expand menu";
                },
            },
            topMenuButtons: {
                get() {
                    let buttons = [
                        {
                            path: "SignOut",
                            name: this.$filters.localize("home.exit"),
                        },
                    ];

                    if (this.$store.getters.isAdmin) {
                        buttons.unshift({
                            path: "SystemSetting",
                            name: this.$filters.localize("home.settings"),
                        });
                        buttons.unshift({
                            path: "Hangfire",
                            name: this.$filters.localize("home.hangfire"),
                        });
                    }
                    buttons.unshift({
                        path: "ProductCategory",
                        name: this.$filters.localize("home.categories"),
                    });

                    return buttons;
                },
            },
            mobileRouteButtons: {
                get() {
                    const mainRoutes = this.leftMenuButtons.filter((button) => this.showByRole(button));
                    const adminRoutes = this.topMenuButtons
                        .filter((button) => button.path !== "SignOut")
                        .filter((button) => this.showByRole(button));

                    return [...mainRoutes, ...adminRoutes];
                },
            },
            leftMenuButtons: {
                get() {
                    return [
                        {
                            path: "DashboardPage",
                            name: this.$filters.localize("home.dashboard"),
                            img: require("@/assets/shop/svg/006-monitor.svg"),
                            isAdmin: true
                        },
                        {
                            path: "Contact",
                            name: this.$filters.localize("home.contacts"),
                            img: require("@/assets/shop/svg/001-man.svg"),
                            isAdmin: false
                        },
                        {
                            path: "Product",
                            name: this.$filters.localize("home.products"),
                            img: require("@/assets/shop/svg/046-stock.svg"), isAdmin: false
                        },
                        {
                            path: "Order",
                            name: this.$filters.localize("home.orders"),
                            img: require("@/assets/shop/svg/036-aggregation.svg"), isAdmin: false
                        },
                        {
                            path: "Promotion",
                            name: this.$filters.localize("home.promotion"),
                            img: require("@/assets/shop/svg/039-gift-card.svg"), isAdmin: false
                        },
                        {
                            path: "Subscribe",
                            name: this.$filters.localize("home.subscribe"),
                            img: require("@/assets/shop/svg/043-notebook.svg"), isAdmin: false
                        },
                        {
                            path: "Withdrawal",
                            name: this.$filters.localize("home.withdrawal"),
                            img: require("@/assets/shop/svg/049-credit-card.svg"), isAdmin: false
                        },
                        {
                            path: "Message",
                            name: this.$filters.localize("home.message"),
                            img: require("@/assets/section/send.svg"), isAdmin: false
                        },
                        {
                            path: "PaymentDetail",
                            name: this.$filters.localize("home.payment"),
                            img: require("@/assets/shop/svg/011-wallet.svg"), isAdmin: false
                        },
                    ];
                },
            },
        },
        data() {
            return {
                isExpanded: false,
            };
        },
        methods: {
            showByRole(button) {
                if (!button.path)
                    return false;

                if (button.isAdmin)
                    return this.$store.getters.isAdmin;
                return true;
            },
        },
    };
</script>

<style scoped>
    .home-layout {
        height: 100vh;
        min-height: 0;
        display: flex;
        overflow: hidden;
        background: #f4f7fb;
    }

    .home-sidebar {
        width: 86px;
        min-width: 86px;
        height: 100vh;
        min-height: 0;
        display: flex;
        flex-direction: column;
        background: linear-gradient(180deg, #0f2641 0%, #173b5d 100%);
        box-shadow: 8px 0 22px rgba(15, 38, 65, 0.14);
        transition: width 0.2s ease, min-width 0.2s ease;
        z-index: 2;
    }

    .home-sidebar--expanded {
        width: 210px;
        min-width: 210px;
    }

    .home-sidebar__top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        min-height: 62px;
        box-sizing: border-box;
        padding: 12px 16px;
    }

    .home-sidebar__logo {
        width: 38px;
        height: 38px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        color: #0f2641;
        background: #ffffff;
        font-size: 1.05rem;
        font-weight: 800;
        line-height: 1;
        box-shadow: 0 8px 18px rgba(0, 0, 0, 0.14);
        transition: width 0.2s ease;
    }

    .home-sidebar__logo--expanded {
        width: 92px;
        padding: 0 12px;
    }

    .home-sidebar__toggle {
        width: 38px;
        height: 38px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border: 1px solid rgba(255, 255, 255, 0.18);
        border-radius: 8px;
        color: #ffffff;
        background: rgba(255, 255, 255, 0.08);
        cursor: pointer;
        transition: background-color 0.2s ease, transform 0.2s ease;
    }

    .home-sidebar__toggle:hover,
    .home-sidebar__toggle:focus {
        background: rgba(255, 255, 255, 0.16);
        outline: none;
    }

    .home-sidebar__toggle:active {
        transform: scale(0.96);
    }

    .home-mobile-exit,
    .home-mobile-tabs {
        display: none;
    }

    .home-main {
        min-width: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    .home-topbar {
        min-height: 34px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 0 14px;
        background: #ffffff;
        border-bottom: 1px solid #e4eaf2;
        box-shadow: 0 4px 18px rgba(15, 38, 65, 0.06);
    }

    .home-content {
        min-height: 0;
        flex: 1;
        overflow: auto;
        text-align: left;
    }

    @media (max-width: 767.98px) {
        .home-layout {
            height: 100dvh;
            flex-direction: column;
            overflow: hidden;
        }

        .home-sidebar {
            width: 100%;
            min-width: 100%;
            height: auto;
            min-height: 54px;
            max-height: 54px;
            flex: 0 0 auto;
            box-shadow: 0 8px 22px rgba(15, 38, 65, 0.12);
        }

        .home-sidebar--expanded {
            max-height: min(70dvh, 520px);
        }

        .home-sidebar__top {
            min-height: 54px;
            padding: 8px 12px;
            justify-content: flex-start;
        }

        .home-sidebar__logo,
        .home-sidebar__logo--expanded {
            width: auto;
            min-width: 38px;
            padding: 0 12px;
        }

        .home-sidebar :deep(.scrolls-enabled) {
            display: none;
        }

        .home-sidebar__toggle {
            display: none;
        }

        .home-mobile-exit {
            margin-left: auto;
            min-height: 34px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 6px 10px;
            border: 1px solid rgba(255, 255, 255, 0.22);
            border-radius: 8px;
            color: #ffffff;
            background: rgba(255, 255, 255, 0.1);
            font-size: 0.72rem;
            font-weight: 800;
            line-height: 1;
            text-transform: uppercase;
            white-space: nowrap;
        }

        .home-mobile-exit:hover,
        .home-mobile-exit:focus {
            color: #ffffff;
            background: rgba(255, 255, 255, 0.18);
        }

        .home-mobile-tabs {
            min-height: 44px;
            display: flex;
            align-items: center;
            gap: 6px;
            padding: 6px 8px;
            overflow-x: auto;
            overflow-y: hidden;
            border-bottom: 1px solid #e4eaf2;
            background: #ffffff;
            box-shadow: 0 4px 14px rgba(15, 38, 65, 0.06);
            scrollbar-width: thin;
        }

        .home-mobile-tabs__link {
            flex: 0 0 auto;
            min-height: 30px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 6px 10px;
            border-radius: 8px;
            color: #173b5d;
            font-size: 0.7rem;
            font-weight: 800;
            line-height: 1;
            text-transform: uppercase;
            white-space: nowrap;
        }

        .home-mobile-tabs__link:hover,
        .home-mobile-tabs__link.router-link-active {
            color: #0f2641;
            background: #e9f0f8;
        }

        .home-main {
            min-height: 0;
            flex: 1;
        }

        .home-topbar {
            display: none;
        }

        .home-content {
            min-height: 0;
            flex: 1;
            overflow-x: auto;
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
        }
    }
</style>
